import { render, staticRenderFns } from "./EnvioInformacion.vue?vue&type=template&id=300f4974&"
import script from "./EnvioInformacion.vue?vue&type=script&lang=ts&"
export * from "./EnvioInformacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports